import type { FC } from 'react';
import React, { isValidElement } from 'react';

import { cnButton } from './Button.cn';
import type { ButtonBaseProps, ButtonProps } from './Button.types';
import { getThemedIcon } from './getThemedIcon';
import type { IconProvider } from './Icon/Button-Icon';
import { ButtonIcon as IconOld } from './Icon/Button-Icon';

type ButtonIconProps = Pick<ButtonBaseProps, 'icon' | 'iconLeft' | 'iconRight'> & {
    size: 's' | 'm' | 'l';
};

const isIconProvider = (icon: ButtonProps['icon']): icon is IconProvider => {
    if (isValidElement(icon)) {
        return false;
    }

    return true;
};

const getIconSize = (buttonSize: ButtonProps['size']) => {
    switch (buttonSize) {
        case 'l':
            return 'l';
        default:
            return 's';
    }
};

export const ButtonIcon: FC<ButtonIconProps> = (props) => {
    const { icon, iconRight, iconLeft, size } = props;

    if (icon && isIconProvider(icon)) {
        return <IconOld provider={icon} className={cnButton('OnlyIcon')} />;
    }

    if (iconLeft && isIconProvider(iconLeft)) {
        return <IconOld provider={iconLeft} side="left" className={cnButton('OnlyIcon')} />;
    }

    if (iconRight && isIconProvider(iconRight)) {
        return <IconOld provider={iconRight} side="right" className={cnButton('OnlyIcon')} />;
    }

    const iconSize = getIconSize(size);
    const themed = getThemedIcon({
        size: iconSize,
        color: 'secondary',
        className: cnButton('Icon'),
    });
    const [themedIcon, themedIconRight] = [icon, iconRight].map(themed);

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>{themedIcon || themedIconRight}</>
    );
};
